<div class="whitespace-nowrap md:text-right text-center grid sm:block grid-cols-2 gap-2">
  @if (resultsStore.isInCompare()(item())) {
    <app-button class="me-2" variant="danger" size="x-small" (click)="resultsStore.removeCompareItem(item())">
      <div class="flex items-center justify-center gap-1">
        <app-icons icon="circle-x" svgClass=""/>
        <span class="md:hidden w-">Remove</span>
      </div>
    </app-button>
  } @else {
    <span>
      <app-button class="me-2 item-add-to-compare" variant="secondary" size="x-small" (click)="compareButtonClicked()" title="Add to compare" aria-label="Add item to compare">
      <div class="flex items-center justify-center gap-1">
        <app-icons icon="arrow-left-arrow-right" svgClass=""/>
        <span class="md:hidden w-">Add to Compare</span>
      </div>
      </app-button>
    </span>
  }
  <span>
    <app-button class="item-add-to-quote" variant="primary" size="x-small" (click)="addToQuoteButtonClicked()" title="Add to quote">
      <div class="flex items-center justify-center gap-1">
      <app-icons icon="add-column-before" svgClass=""/>
        <span class="md:hidden">Add to Quote</span>
      </div>
    </app-button>
  </span>
</div>
